import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  restaurantConfig : {},
  status: "idle",  
  error: null,
};
const restaurantConfigSlice = createSlice({
  name: "restaurantConfig",
  initialState,
  reducers: {
    setRestaurantConfig: (state, action) => {
      const { restaurantConfig } = action.payload;
      state.restaurantConfig = restaurantConfig;
      state.status = "succeeded";
      state.error = null;
    },
    setError(state, action) {
    state.error = action.payload;
    state.status = "failed";
  },
    clearRestaurantConfig: (state) => {
      state.restaurantConfig = {};
      state.status = "idle";
      state.error = null;
    },
    updateRestaurantConfigInfo: (state, action) => {
      const { id, name } = action.payload;
      if (!state.restaurantConfig) return;
      for (const rest of state.restaurantConfig) {
        const item = rest.items.find((i) => i.id === id);
        if (item) {
          item.name = name;
          break;
        }
      }
    },
  },
});

export const { setRestaurantConfig,setError,clearRestaurantConfig,updateRestaurantConfigInfo } = restaurantConfigSlice.actions;
export default restaurantConfigSlice.reducer;